import React, { useEffect, useState, useRef } from "react";
import Modal from "react-modal";
import MessageBox from "./MessageBox";
import alfredoIcon from "../assets/alfredo-icon.svg";
import api from "../services/api.service";
import {
  Button,
  CloseButton,
  DropDown,
  Input,
  ModalContent,
  ModalWrapper,
  Title,
  customStyles,
} from "../styles/Login.styles";

const LoginModal: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
  onLogin: (userEmail: string, userPassword: string) => void;
}> = ({ isOpen, onRequestClose, onLogin }) => {
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [emailOptions, setEmailOptions] = useState<string[]>([]);
  const passwordInputRef = useRef<HTMLInputElement>(null);

  // Função para buscar os emails
  const GetUsersEmails = async () => {
    try {
      const response = await api.get("/opsUserEmails");
      if (response.status !== 200) {
        throw new Error(response.data.message);
      }
      setEmailOptions(response.data);
      setUserEmail(response.data[0]);
    } catch (error) {
      console.error("Erro ao buscar os emails:", error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      GetUsersEmails();
      setTimeout(() => {
        passwordInputRef.current?.focus();
      }, 0);
    }
  }, [isOpen]);

  const handleLogin = () => {
    onLogin(userEmail, userPassword);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    // Atualizar o estado userEmail quando o dropdown for alterado
    setUserEmail(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel="Login Modal"
      ariaHideApp={false}
    >
      <ModalWrapper>
        <ModalContent>
          <CloseButton onClick={onRequestClose}>&times;</CloseButton>
          <img src={alfredoIcon} alt="Alfredo Ops" style={{ width: '35%', height: '35%' }} />
          <Title>A L F R E D O OPERAÇÕES</Title>
          <DropDown onChange={handleEmailChange}>
            {emailOptions?.map((userEmail, index) => (
              <option key={index} value={userEmail}>
                {userEmail}
              </option>
            ))}
          </DropDown>
          <Input
            ref={passwordInputRef}
            type="password"
            placeholder="Senha"
            value={userPassword}
            onChange={(e) => setUserPassword(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <Button onClick={handleLogin}>Acessar</Button>
        </ModalContent>
      </ModalWrapper>
    </Modal>
  );
};

export default LoginModal;
